module.exports = __webpack_public_path__ + "static/media/MiSensorLogo_Icon.7aefb7ac.svg";